import type { AxiosError } from 'axios';

import { isJSendError } from '@/utils/jSend/types';

export interface AxiosErrorLogEntry {
  message: string;
  method?: string;
  url?: string;
  status?: number;
  code?: string;
  responseMessage?: string;
  responseCode?: string;
}

interface AxiosErrorLogOptions {
  redactLastPathSegment?: boolean;
}

const sanitizeUrl = (
  url: string | undefined,
  options: AxiosErrorLogOptions,
): string | undefined => {
  const path = url?.split('?')[0];

  return options.redactLastPathSegment === true
    ? path?.replace(/[^/]+$/, '<redacted>')
    : path;
};

const readResponseCode = (data: Record<string, unknown> | undefined) => {
  const code = data?.code ?? data?.identifier;

  return typeof code === 'string' ? code : undefined;
};

/**
 * Bewusst ohne config.data, Header, Response-Body und Query-String:
 * dort stecken die eingegebenen Kundendaten, die nicht in Loki landen dürfen (VGL-7106).
 */
export const toAxiosErrorLogEntry = (
  error: AxiosError,
  options: AxiosErrorLogOptions = {},
): AxiosErrorLogEntry => {
  const entry: AxiosErrorLogEntry = {
    message: error.message,
    method: error.config?.method?.toUpperCase(),
    url: sanitizeUrl(error.config?.url, options),
    status: error.response?.status,
    code: error.code,
  };

  const responseData = error.response?.data;
  if (isJSendError(responseData)) {
    entry.responseMessage = responseData.message;
    entry.responseCode = readResponseCode(responseData.data);
  }

  return entry;
};
